"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_INITIAL_DEVICE_DATA = exports.RESET_STRUCTURE = void 0;
var _constants = require("../../utils/constants");
const SET_INITIAL_DEVICE_DATA = "SET_INITIAL_DEVICE_DATA".concat(_constants.packagePrefix);
exports.SET_INITIAL_DEVICE_DATA = SET_INITIAL_DEVICE_DATA;
const RESET_STRUCTURE = "RESET_STRUCTURE".concat(_constants.packagePrefix);
exports.RESET_STRUCTURE = RESET_STRUCTURE;